<template>
  <div>
    <div>
      <vAlertHeader
        :title="
          groupTable
            ? '2. SELECT ' + groupTable.toUpperCase()
            : '2. ADD MEMBERS'
        "
        :color="getThemeColor"
        class="mb-n4"
      ></vAlertHeader>

      <v-card>
        <v-toolbar color class="mb-1">
          <v-toolbar-title
            :style="{ color: getOutlineColor }"
            v-if="groupTable"
          >
            {{ groupTable.toUpperCase() + " " + members.length }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
            v-model="groupMembersSwitch"
            class="mt-6 mr-2"
            label="All"
            @change="selectAllGroupMembersWhenSwitchIsTrue()"
          ></v-switch>
          <v-btn
            color="#E65100"
            dark
            class="mb-2"
            @click="emitAddMemberDialog"
            v-if="
              !groupTable ||
                (groupTable != 'students' &&
                  groupTable != 'staff' &&
                  groupTable != 'users')
            "
          >
            New Members
          </v-btn>
          <v-btn
            color="#E65100"
            dark
            class="mb-2"
            @click="routeToManageStaff"
            v-else-if="groupTable && groupTable == 'staff'"
          >
            Add Staff
          </v-btn>
          <!-- <v-text-field
                class="ml-4"
                :label=" searchTableTitle ? searchTableTitle.toUpperCase(): 'Search Contact'"
                @blur="getSearchedMember"
                append-icon="mdi-magnify"
              ></v-text-field> -->
          <v-icon
            color="red"
            class="ml-4"
            @click="openConfirmDeleteDialog('groups')"
            v-if="
              groupTable &&
                groupTable != 'staff' &&
                groupTable != 'students' &&
                groupTable != 'users'
            "
            >mdi-delete</v-icon
          >
        </v-toolbar>
        <v-virtual-scroll :items="members" height="600" item-height="130">
          <template v-slot:default="props">
            <v-list two-line>
              <v-list-item :key="props.index + Math.random()">
                <v-list-item-content>
                  <v-list-item-title class="mb-6">{{
                    props.item.name
                  }}</v-list-item-title>
                  <v-list-item-title v-if="props.item.tel">
                    <input
                      :style="{
                        border: 'none',
                        'border-bottom': '1px solid black',
                      }"
                      :value="props.item.tel"
                      @blur="updateItem(props.item)"
                    />
                  </v-list-item-title>
                  <v-list-item-title v-else-if="props.item.phone">
                    <input
                      :style="{
                        border: 'none',
                        'border-bottom': '1px solid black',
                      }"
                      :value="props.item.phone"
                      @blur="updateItem(props.item)"
                    />
                  </v-list-item-title>
                  <v-list-item-title v-else-if="props.item.phone_number">
                    <input
                      :style="{
                        border: 'none',
                        'border-bottom': '1px solid black',
                      }"
                      :value="props.item.phone_number"
                      @blur="updateItem(props.item)"
                    />
                  </v-list-item-title>
                  <v-list-item-title v-else>
                    <input
                      :style="{
                        border: 'none',
                        'border-bottom': '1px solid black',
                      }"
                      @blur="updateItem(props.item)"
                    />
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-checkbox
                    v-if="
                      props.item.phone_number ||
                        props.item.phone ||
                        props.item.tel
                    "
                    dense
                    class="shrink mx-n4"
                    :value="props.item"
                    v-model="selectedMembersForSMSSending"
                    @change="emitSelectedMembers"
                  ></v-checkbox>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </template>
        </v-virtual-scroll>
      </v-card>
    </div>
  </div>
</template>

<script>
import crudJs from "@/plugins/crud";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";
export default {
  components: { vAlertHeader },
  props: {
    selectedMembers: {
      default: () => [],
    },
  },
  computed: {
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUpdateItemRoute() {
      return this.$store.getters.getUpdateItemRoute;
    },
  },
  watch: {
    selectedMembers(newMembers) {
      this.loadMembers(newMembers);
    },
  },
  data: () => ({
    groupTable: null,
    members: [],
    selectedMembersForSMSSending: [],
    groupMembersSwitch: false,
  }),
  mounted() {
    this.loadMembers(this.selectedMembers);
  },
  methods: {
    async updateItem(item) {
      this.$store.commit("setLoader", true);
      const value = event.target.value;
      let column = "";
      if (item.table == "staff") {
        column = "phone";
      } else if (item.table == "students") {
        column = "tel";
      } else if (item.table == "users") {
        column = "phone_number";
      } else {
        column = "phone_number";
      }
      const updatedItem = await crudJs.updateField(
        item.table,
        column,
        value,
        item.id
      );

      const index = this.selectedMembers.findIndex((member) => {
        return member.id == item.id;
      });
      this.selectedMembers[index]["phone"] = value;
      this.$store.commit("setLoader", false);
    },
    loadMembers(selectedMembers) {
      if (selectedMembers.length > 0) {
        this.groupTable = selectedMembers[0]["table"];
        this.members = selectedMembers;
        // this.selectAllMembers();
      } else {
        this.groupTable = null;
        this.members = [];
      }
    },
    emitAddMemberDialog() {
      this.$emit("open-add-new-member-dialog", this.groupTable);
    },
    selectAllGroupMembersWhenSwitchIsTrue() {
      if (this.groupMembersSwitch) {
        this.selectAllMembers();
      } else {
        this.selectedMembersForSMSSending = [];
      }
      this.emitSelectedMembers();
    },
    routeToManageStaff() {
      this.$router.push({ path: "/manage-employees" });
    },
    emitSelectedMembers() {
      this.$emit("selected-members", this.selectedMembersForSMSSending);
    },
    selectAllMembers() {
      if (this.members.length > 0) {
        this.groupMembersSwitch = true;
        this.selectedMembersForSMSSending = [];
        this.members.forEach((member) => {
          this.selectedMembersForSMSSending.push(member);
        });
        this.emitSelectedMembers();
      }
    },
  },
};
</script>
